import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { MonetaryAmountOptionSelector } from '@fhs/ui';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { useServiceModeContext } from '@fhs-legacy/frontend/src/state/service-mode';
import { isDelivery } from '@fhs-legacy/frontend/src/utils/service-mode';
import { CHECKOUT_ORDER_SUMMARY_TIP } from '@fhs-legacy/frontend/src/utils/test-ids';

import { useTipStore } from '../../../../state/tip-store';

const TIP_OPTIONS = [
  { value: '15', label: '15%' },
  { value: '18', label: '18%' },
  { value: '20', label: '20%' },
];

export function TipRow() {
  const { serviceMode } = useServiceModeContext();
  const { serverOrder } = useCartContext();
  const selectedTip = useTipStore(state => state.selectedTip);
  const otherTipValue = useTipStore(state => state.otherTipValue);
  const setSelectedTip = useTipStore(state => state.setSelectedTip);
  const setOtherTipValue = useTipStore(state => state.setOtherTipValue);
  const calculateTipCents = useTipStore(state => state.calculateTipCents);
  const validateTip = useTipStore(state => state.validateTip);

  // Use discount amount with subtotal to use for the calculated tip amount
  const discountAmount = useMemo(() => {
    const discounts = serverOrder?.cart?.discounts || [];
    return discounts.reduce((sum, d) => sum + d.value, 0);
  }, [serverOrder?.cart?.discounts]);

  if (!isDelivery(serviceMode)) {
    return null;
  }

  const subTotalCents = serverOrder?.cart?.subTotalCents ?? 0;
  const tipAmountCents = calculateTipCents(subTotalCents, discountAmount);

  const { errorMessage } = validateTip(subTotalCents);

  return (
    <View testID={CHECKOUT_ORDER_SUMMARY_TIP} style={styles.row}>
      <MonetaryAmountOptionSelector
        value={selectedTip}
        otherValue={otherTipValue}
        amountCents={tipAmountCents}
        amountOptions={TIP_OPTIONS}
        otherValueLabel="Tip Amount"
        errorMessage={errorMessage}
        onSelect={setSelectedTip}
        onChangeOtherValue={setOtherTipValue}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    paddingVertical: 8,
    paddingHorizontal: 28,
    marginBottom: 16,
  },
});
